import styled from "styled-components";
import { Modal, Button, Form, Radio } from "antd";

export const StyledModal = styled(Modal)`
  .ant-modal {
    width: 677px !important;
  }

  .ant-modal-content {
    border-radius: 8px;
    width: 100%;
    height: auto;
  }

  .ant-modal-header {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .ant-modal-footer {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .ant-modal-title {
    font-family: "Open Sans", sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0;
    vertical-align: middle;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  font-family: Open Sans;
  font-weight: 600px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18.86px;
  letter-spacing: 0%;
  vertical-align: middle;
`;

export const InstanceTitle = styled.h4`
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 18.86px;
  letter-spacing: 0%;
  vertical-align: middle;
`;

export const ScrollableContent = styled.div`
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
`;

export const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-inner {
    background-color: rgba(0, 34, 68, 1);
    border-color: rgba(0, 34, 68, 1);
  }

  .ant-radio-checked .ant-radio-inner::after {
    background-color: white;
  }
`;

export const AddAnotherInstanceButton = styled.div`
  margin-top: 16px;
  font-family: Open Sans;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  cursor: pointer;
  color: rgba(0, 34, 68, 1);
`;

export const RemoveInstanceButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Open Sans;
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  text-transform: uppercase;
  cursor: pointer;
  color: red;
  margin-top: -15px;
  margin-bottom: 25px;
`;

export const StyledButton = styled(Button)`
  width: 112px;
  height: 34px;
  gap: 8px;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 25.14px;
  text-align: center;
  vertical-align: middle;
  border-radius: 5px;

  background-color: ${(props) =>
    props.isCancel ? "rgba(254,202,202,1)" : "rgba(0, 34, 68, 1)"};
  border: ${(props) =>
    props.isCancel ? "none" : "1px solid rgba(0, 34, 68, 1)"};
  color: ${(props) => (props.isCancel ? "rgb(153, 27, 27)" : "white")};

  &:hover,
  &:focus {
    background-color: ${(props) =>
      props.isCancel ? "rgba(248, 191, 191, 1)" : "rgba(0, 50, 100, 1)"};
    border-color: ${(props) =>
      props.isCancel ? "none" : "rgba(0, 50, 100, 1)"};
    color: ${(props) => (props.isCancel ? "rgb(153, 27, 27)" : "white")};
  }
`;

export const SpaceInfoDontNeedApproval = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f1f5f9;
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #314158;
  padding: 10px;
`;

export const TextDontNeedApproval = styled.span`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #314158;
`;
